import update from 'immutability-helper';
import _ from 'lodash';
import type { GetAnnouncementStreamItems } from '../queries/__generated__/GetAnnouncementStreamItems';
import type { SequenceItemFragment } from 'chat/components/Stream/fragments/__generated__/SequenceItemFragment';

export function addSequenceItemsToQueryResult(
  result: GetAnnouncementStreamItems,
  newSequenceItems: Array<SequenceItemFragment>
): GetAnnouncementStreamItems {
  const oldItems = result.entityStreams?.[0]?.sequenceItems || [];
  const newItems = newSequenceItems;

  const sortedArray = [...newItems, ...oldItems].sort((a, b) => {
    if (Number(a.seq) > Number(b.seq)) {
      return -1;
    }

    if (Number(a.seq) < Number(b.seq)) {
      return 1;
    }

    return 0;
  });

  return update(result, {
    entityStreams: {
      '0': { sequenceItems: { $set: _.uniqBy(sortedArray, 'key') } },
    },
  });
}
